"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_toolbar_button_html_1 = __importDefault(require("./widget-toolbar-button.html"));
(function (module) {
    module.component('prWidgetToolbarButton', {
        templateUrl: widget_toolbar_button_html_1.default,
        bindings: {
            icon: '<',
            tooltip: '<',
            action: '&?',
            value: '<',
            selected: '='
        }
    });
})(angular.module('qualtrics.pr'));
